import { render } from "./AddBescStep3Page.vue?vue&type=template&id=199982d0&ts=true"
import script from "./AddBescStep3Page.vue?vue&type=script&lang=ts"
export * from "./AddBescStep3Page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__